<div class="strength">
  <ul class="strength__bar">
    <li
      class="strength__point"
      *ngFor="let bar of bars; let i = index"
      [style.background-color]="bar"
    ></li>
  </ul>
</div>
